import { createFileRoute } from '@tanstack/react-router'

import { AnalysisScreen } from '@/features/market/analysis-screen'
import { marketSearchSchema } from '@/features/market/market-search'

/** A spec's page over every listing the Market's filters let by: the analysis of a selection. */
export const Route = createFileRoute('/_app/platform/market/analysis')({
  validateSearch: (search) => marketSearchSchema.parse(search),
  component: AnalysisScreen,
})
